import { paths } from 'src/routes/paths';

import { normalizeReturnToParam } from './return-to-storage';

/**
 * returnTo·로그인 직후 목적지가 랜딩(`/`) 또는 `/home`이면 서비스 루트로 통일합니다.
 * ⛔ 같은 사이트 밖으로 읽히는 값(`//…` · `/\…` · 스킴)도 서비스 루트로 접는다(`normalizeReturnToParam`).
 * 경로 안의 인코딩(`?question=…%26…`)은 그대로 둔다 — 다시 디코드하면 질의가 쪼개진다.
 * @param {string | null | undefined} raw — `returnTo` 또는 `paths.home.root` 등
 * @returns {string}
 */
export function resolvePostLoginPath(raw: string | null | undefined): string {
  const path = normalizeReturnToParam(raw);
  if (!path) return paths.service.root;

  const pathPart = path.split('?')[0] || '';
  const pathname = (pathPart.replace(/\/$/, '') || '/');

  if (pathname === '/' || pathname === '/home') {
    return paths.service.root;
  }

  return path;
}
